<ac-drop-down #dualList [parentClass]="'dual-list-component'"
              (openStatusChanged)="setDropdownArrow($event)">

  <div parent class="ac-dropdown-toggle dual-list-preview">
    <ac-input-container class="fullWidth">
      <ac-textfield style="display: none"></ac-textfield>
      <div class="title" title="{{header}}">{{header}}</div>
      <div class="actions">
        <a class="clear" [hidden]="isTargetEmpty()" (click)="removeSelectedItems($event)"><span class="fa fa-times"></span></a>
        <a class="toggle"><span class="fa arrow fa-sort-down"></span></a>
      </div>
    </ac-input-container>
  </div>

  <div tooltip class="dual-list-tooltip" [ngClass]="{'show-value': showValue}">
    <div class="dual-list">
      <div class="table-container">
        <div class="list-title">{{sourceHeader}}</div>
        <div class="source-container">
          <div class="inner-list-container">
            <table mat-table [dataSource]="innerSourceList">
              <ng-container matColumnDef="name">
                <td mat-cell *matCellDef="let item">{{item[bindLabel]}}</td>
              </ng-container>

              <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                  class="path-row" (click)="onSelectFromSource(row)" [ngClass]="{'selected': isSelectedInSource(row)}">
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div class="move-to-another-list-buttons">
        <i class="fa fa-angle-right" (click)="addToTarget()" [ngClass]="{'fa-disabled': !hasItemsToAdd() || value}"></i>
        <i class="fa fa-angle-left" (click)="removeFromTarget()" [ngClass]="{'fa-disabled': !hasItemsToRemove()}"></i>
      </div>

      <div>
        <div class="list-title">{{targetHeader}}</div>
        <div class="target-container">
          <div class="inner-list-container">
            <table mat-table [dataSource]="innerTargetList">
              <ng-container matColumnDef="name">
                <td mat-cell *matCellDef="let item">{{item[bindLabel]}}</td>
              </ng-container>

              <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                  class="path-row" (click)="onSelectFromTarget(row)" [ngClass]="{'selected': isSelectedInTarget(row)}">
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div class="move-inside-list-buttons">
        <i class="fa fa-angle-up" (click)="moveUp()" [ngClass]="{'fa-disabled': !isUpAvailable()}"></i>
        <i class="fa fa-angle-down" (click)="moveDown()" [ngClass]="{'fa-disabled': !isDownAvailable()}"></i>
      </div>
    </div>

    <ac-input-container *ngIf="showValue" label="Replacement value" class="dual-list-text-area">
      <ac-textfield textFieldId="dual-list-text-area"
                    [(acModel)]="value"
                    [ngDisabled]="innerTargetList.data.length > 0 && !value"
                    maxlength="255">
      </ac-textfield>
    </ac-input-container>
    <div class="dual-list-buttons">
      <ac-button class="apply-button"
                 [buttonValue]="'Apply'"
                 (acClick)="onApply(); dualList.close()">
      </ac-button>

      <ac-button [buttonValue]="'Cancel'"
                 (acClick)="dualList.close()">
      </ac-button>
    </div>
  </div>
</ac-drop-down>
